// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.custom-ui {
  font-family: "OpenSans-Regular";
  color: var(--undp-jtf-text-color);
}

.wrap-words {
  word-wrap: break-word;
}

.flex-detail-card-wrapper {
  background: linear-gradient(135deg, var(--undp-jtf-primary-color), var(--undp-jtf-btn-dark-color));
  padding: 24px;
  margin: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  width: 100%;
}

.flex-detail-card-row {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
@media (max-width: 850px) {
  .flex-detail-card-row {
    flex-direction: column-reverse;
    gap: 12px;
  }
}

.flex-detail-card-info-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.flex-detail-card-info-row span {
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
}
.flex-detail-card-info-row span .fontPrimaryRegular {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
}

.post-action-btn {
  cursor: pointer;
  width: 18px;
  height: 18px;
  filter: brightness(0) invert(1);
  transition: all 0.2s ease;
  opacity: 0.9;
}
.post-action-btn:hover {
  opacity: 1;
}

.flex-detail-card-column-wrapper {
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 180px);
}
.flex-detail-card-column-wrapper .fontPrimaryBold {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 8px;
}
@media (max-width: 850px) {
  .flex-detail-card-column-wrapper {
    max-width: 100%;
  }
}
@media (max-width: 400px) {
  .flex-detail-card-column-wrapper {
    width: 100%;
  }
}

.flex-post-actions {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
@media (max-width: 850px) {
  .flex-post-actions {
    align-self: flex-end;
  }
}
.flex-post-actions__toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.post-action-btn-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  line-height: 0;
  box-shadow: none;
}
.post-action-btn-wrap.dropdown-toggle {
  padding: 10px;
}
.post-action-btn-wrap.dropdown-toggle::after {
  display: none;
}
.post-action-btn-wrap:hover, .post-action-btn-wrap.dropdown-toggle:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}
.post-action-btn-wrap:active, .post-action-btn-wrap.dropdown-toggle:active, .post-action-btn-wrap.dropdown-toggle.show {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(0);
  box-shadow: none;
}
.post-action-btn-wrap:focus, .post-action-btn-wrap:focus-visible, .post-action-btn-wrap.dropdown-toggle:focus, .post-action-btn-wrap.dropdown-toggle:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: 2px;
  box-shadow: none;
}
.post-action-btn-wrap .post-action-btn {
  pointer-events: none;
}

.post-action-dropdown {
  display: inline-flex;
}

.text-align {
  text-align: right;
}

.notifications-dropdown {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #e2e8f0;
  padding: 8px;
  margin-top: 8px;
  max-height: 400px;
  overflow-y: auto !important;
  overflow-x: hidden;
  z-index: 1050 !important;
  position: relative;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
.notifications-dropdown .ngbDropdownItem {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;
}
.notifications-dropdown .ngbDropdownItem:hover {
  background: #f0f9ff;
  border-color: #e0f2fe;
}
.notifications-dropdown .ngbDropdownItem:last-child {
  margin-bottom: 0;
}
.notifications-dropdown .ngbDropdownItem .col {
  font-size: 13px;
  line-height: 1.8;
  color: #334155;
  word-break: break-word;
}
.notifications-dropdown .ngbDropdownItem .col fa-icon {
  color: var(--undp-jtf-primary-color);
  margin-right: 8px;
}
.notifications-dropdown .ngbDropdownItem .col .fontPrimaryMedium {
  font-weight: 600;
  color: var(--undp-jtf-primary-color);
}
.notifications-dropdown::-webkit-scrollbar {
  width: 6px;
}
.notifications-dropdown::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}
.notifications-dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.notifications-dropdown::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-actions/post-actions.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,+BCEqB;EDDrB,iCAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,kGAAA;EACA,aAAA;EACA,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAEF;AAAE;EATF;IAUI,8BAAA;IACA,SAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAGF;AADE;EACE,+BAAA;EACA,eAAA;AAGJ;AADI;EACE,+BAAA;EACA,gBAAA;AAGN;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;EACA,YAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,OAAA;EACA,YAAA;EACA,6BAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAGE;EAbF;IAcI,eAAA;EAAF;AACF;AAEE;EAjBF;IAkBI,WAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AACF;AACE;EANF;IAOI,oBAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAEJ;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;AAEE;EACE,aAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAIE;EAEE,qCAAA;EACA,2BAAA;AAHJ;AAME;EAGE,qCAAA;EACA,wBAAA;EACA,gBAAA;AANJ;AASE;EAIE,4CAAA;EACA,mBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,oBAAA;AAXJ;;AAeA;EACE,oBAAA;AAZF;;AAeA;EACE,iBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;AAZF;AAcE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,6BAAA;AAZJ;AAcI;EACE,mBAAA;EACA,qBAAA;AAZN;AAeI;EACE,gBAAA;AAbN;AAgBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAdN;AAgBM;EACE,oCAAA;EACA,iBAAA;AAdR;AAiBM;EACE,gBAAA;EACA,oCAAA;AAfR;AAoBE;EACE,UAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,mBAAA;EACA,kBAAA;AApBJ;AAsBI;EACE,mBAAA;AApBN","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\n\n.custom-ui {\n  font-family: $primary-font-regular;\n  color: var(--undp-jtf-text-color);\n}\n\n.wrap-words {\n  word-wrap: break-word;\n}\n\n.flex-detail-card-wrapper {\n  background: linear-gradient(135deg, var(--undp-jtf-primary-color), var(--undp-jtf-btn-dark-color));\n  padding: 24px;\n  margin: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  width: 100%;\n}\n\n.flex-detail-card-row {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n\n  @media (max-width: 850px) {\n    flex-direction: column-reverse;\n    gap: 12px;\n  }\n}\n\n.flex-detail-card-info-row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n  \n  span {\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 13px;\n    \n    .fontPrimaryRegular {\n      color: rgba(255, 255, 255, 0.7);\n      font-weight: 400;\n    }\n  }\n}\n\n.post-action-btn {\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  filter: brightness(0) invert(1);\n  transition: all 0.2s ease;\n  opacity: 0.9;\n  \n  &:hover {\n    opacity: 1;\n  }\n}\n\n.flex-detail-card-column-wrapper {\n  flex: 1;\n  min-width: 0;\n  max-width: calc(100% - 180px);\n  \n  .fontPrimaryBold {\n    color: #ffffff;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1.4;\n    margin-bottom: 8px;\n  }\n  \n  @media (max-width: 850px) {\n    max-width: 100%;\n  }\n  \n  @media (max-width: 400px) {\n    width: 100%;\n  }\n}\n\n.flex-post-actions {\n  display: flex;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n\n  @media (max-width: 850px) {\n    align-self: flex-end;\n  }\n  \n  &__toolbar {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}\n\n.post-action-btn-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  line-height: 0;\n  box-shadow: none;\n\n  // ngbDropdownToggle adds .dropdown-toggle (Bootstrap caret + btn styles)\n  &.dropdown-toggle {\n    padding: 10px;\n\n    &::after {\n      display: none;\n    }\n  }\n\n  &:hover,\n  &.dropdown-toggle:hover {\n    background: rgba(255, 255, 255, 0.25);\n    transform: translateY(-2px);\n  }\n\n  &:active,\n  &.dropdown-toggle:active,\n  &.dropdown-toggle.show {\n    background: rgba(255, 255, 255, 0.25);\n    transform: translateY(0);\n    box-shadow: none;\n  }\n\n  &:focus,\n  &:focus-visible,\n  &.dropdown-toggle:focus,\n  &.dropdown-toggle:focus-visible {\n    outline: 2px solid rgba(255, 255, 255, 0.85);\n    outline-offset: 2px;\n    box-shadow: none;\n  }\n\n  .post-action-btn {\n    pointer-events: none;\n  }\n}\n\n.post-action-dropdown {\n  display: inline-flex;\n}\n\n.text-align {\n  text-align: right;\n}\n\n.notifications-dropdown {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e2e8f0;\n  padding: 8px;\n  margin-top: 8px;\n  max-height: 400px;\n  overflow-y: auto !important;\n  overflow-x: hidden;\n  z-index: 1050 !important;\n  position: relative;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  \n  .ngbDropdownItem {\n    padding: 16px;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    border: 1px solid transparent;\n    \n    &:hover {\n      background: #f0f9ff;\n      border-color: #e0f2fe;\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n    \n    .col {\n      font-size: 13px;\n      line-height: 1.8;\n      color: #334155;\n      word-break: break-word;\n      \n      fa-icon {\n        color: var(--undp-jtf-primary-color);\n        margin-right: 8px;\n      }\n      \n      .fontPrimaryMedium {\n        font-weight: 600;\n        color: var(--undp-jtf-primary-color);\n      }\n    }\n  }\n  \n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f5f9;\n    border-radius: 3px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 3px;\n    \n    &:hover {\n      background: #94a3b8;\n    }\n  }\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
